import type { UserRes } from 'api/swagger/index.ts';
import { createStore } from './create-store';

type TState = {
  user?: UserRes;
  isAuth: boolean;
};

type TActions = {
  setAuth: (user: UserRes) => void;
  clearAuth: () => void;
};

export const useAuthStore = createStore<TState & TActions>(
  (set) => ({
    user: undefined,
    isAuth: false,
    setAuth: (user: UserRes) => set(() => ({ user, isAuth: true })),
    clearAuth: () => set(() => ({ user: undefined, isAuth: false })),
  }),
  'auth-store',
);
